import { ReduxStore } from 'store/types';

function getSearchedInterventionEmptyMsg(state: ReduxStore): string {
  return state.intervention.getSearchedIntervention.config.emptyMsg;
}

export default getSearchedInterventionEmptyMsg;
